import { ToastContext } from "../utils/ToastContext";
import React, { useState, useEffect, useContext } from "react";
import { Snackbar, Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";

const ToastComponent = () => {
  const StyledAlert = styled(Alert)(({ theme }) => ({
    width: "100%",
    height: "50px",
    fontSize: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // border:"2px solid #CBCDFB"
  }));

  const {
    message,
    isVisible,
    closeToast,
    type,
    duration = 1500,
    onClose,
  } = useContext(ToastContext);

  const [openToast, setOpenToast] = useState(isVisible);

  // if (!isVisible) return null

  useEffect(() => {
    if (isVisible) {
      setOpenToast(true);
    }
  }, [isVisible]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToast(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Snackbar
      open={openToast}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      TransitionProps={{ onExited: onClose }}
      sx={{
        // "& .MuiSnackbarContent-root": {
        //   borderRadius: "20px",
        // },
        borderRadius:"20px",
        zIndex:"9999"
      }}
    >
      <StyledAlert
        variant="filled"
        // color={"success"}
        onClose={handleClose}
        severity={type}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="medium"
            onClick={handleClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{
        borderRadius:"20px",
        }}
      >
        {message}
      </StyledAlert>
    </Snackbar>
  );
};

export default ToastComponent;